/**
 * Loading Screen UI
 */
export const splashAssets = {    
    splashAtlas: 'images/Splash.json',
    loadingBarAtlas: 'images/LoadingBar.json',
    cnAtlas: 'images/CNSplash.json',
    stevenAtlas: 'images/StevenSplash.json',
    loadingBg: './images/Backgrounds/LoadingBG.jpg'
};

export const atlases = {
    selectGridAtlas: 'images/selectGrid.json',
    selectPreview: 'images/selectPreview.json',
    boardElements: 'images/BoardElements.json',
    gameUIElements: 'images/GameUIElements.json',
    charactersLose: 'images/CharactersLose.json',
    charactersWin: 'images/CharactersWin.json',
    charactersMenuSelect: 'images/CharactersMenuSelect.json',
    gameOverElements0: 'images/GameOverElements_0.json',
    gameOverElements1: 'images/GameOverElements_1.json',
    backgrounds0: 'images/Backgrounds_0.json',
    backgrounds1: 'images/Backgrounds_1.json',
    backgrounds2: 'images/Backgrounds_2.json',
    backgrounds3: 'images/Backgrounds_3.json',
    backgrounds4: 'images/Backgrounds_4.json',
    backgrounds5: 'images/Backgrounds_5.json',
    character_amethyst: 'images/InGameCharacters/amethyst.json',
    character_garnet: 'images/InGameCharacters/garnet.json',
    character_jasper: 'images/InGameCharacters/jasper.json',
    character_pearl: 'images/InGameCharacters/pearl.json',
    character_peridot: 'images/InGameCharacters/peridot.json',
    character_steven: 'images/InGameCharacters/steven.json',
    character_yd: 'images/InGameCharacters/yd.json',
    character_minions: 'images/InGameCharacters/minions.json',
    tutorial0: 'images/Tutorial_0.json',
    tutorial1: 'images/Tutorial_1.json'
}

export const stage2Elements = {
    stage2NameSprite: 'images/StageMap/Stage2/StageNameSprite.png',
    stage2SelectionHighligth: 'images/StageMap/Stage2/StageSelectionHighligth.png',
    stage2SelectionIcon: 'images/StageMap/Stage2/StageSelectionIcon.png',
};

export const stage1Elements = {
    stage1NameSprite: 'images/StageMap/Stage1/StageNameSprite.png',
    stage1SelectionHighligth: 'images/StageMap/Stage1/StageSelectionHighligth.png',
	stage1SelectionIcon: 'images/StageMap/Stage1/StageSelectionIcon.png',
	testPath: 'images/StageMap/pathTest.png',
};

export const stage3Elements = {
    stage3SelectionIcon: 'images/StageMap/Stage3/StageSelectionIcon.png'
};

/**
 * Game sounds Imports
 * ====================================================================================================
 */

export const gameSFX =
{
	gemCollectSound: 'sounds/gameplaySounds/SFX/gemCollect.mp3',
	gemRotateSound: 'sounds/gameplaySounds/SFX/gemRotate.mp3',
	gemDropSound: 'sounds/gameplaySounds/SFX/gemDrop.mp3',
	bubbleTickSound: 'sounds/gameplaySounds/SFX/bubbleTick.mp3',
	activateSpecialSound: 'sounds/gameplaySounds/SFX/activateSpecial.mp3',
	pauseSound: 'sounds/gameplaySounds/SFX/gamePause.mp3',
	menuMoveSound: 'sounds/gameplaySounds/SFX/menuMove.mp3',
	menuSelectSound: 'sounds/gameplaySounds/SFX/menuSelect.mp3',
	nextLvlSound: 'sounds/gameplaySounds/SFX/arcadeNextLvl.mp3',
    powerupReady: 'sounds/gameplaySounds/SFX/menuSelect.mp3'
}

export const gameBGX =
{
	bgCharacterSelect: 'sounds/gameplaySounds/BGX/characterSelect.mp3',
	bgMainTheme: 'sounds/gameplaySounds/BGX/mainTheme.mp3',
	bgVsPeridot: 'sounds/gameplaySounds/BGX/vsPeridot.mp3',
	bgVsJasper: 'sounds/gameplaySounds/BGX/vsJasper.mp3',
	bgVsYellowDiamond: 'sounds/gameplaySounds/BGX/vsYellowDiamond.mp3',
	bgVictory: 'sounds/gameplaySounds/BGX/victory.mp3',
	bgDefeat: 'sounds/gameplaySounds/BGX/defeat.mp3',
}
